import loadable from '@loadable/component';

const NotFound = loadable(() => import('./NotFound'));

export default [
  {
    path: '*',
    component: NotFound,
    title: '404 Not Found',
    breadcrumbs: [],
    exact: true,
  },
];
